import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ user, redirectTo = "/" }) => {
    // Not logged in
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
